import React, { useEffect, useState } from "react";
// import { ReactComponent as StarIcon } from '../../../icons/StarIcon.svg';
import { useLoadCommunities } from "../../../hooks/apphooks";
import { CommunitySchema } from '../../../data/types';
import CommunityCardSkeleton from "../../../components/CommunityCardSkeleton";
import { CommunityResourcesModal } from "../../../molecules/Mobile/AppModal";
import {CommunityCard} from "../../../components/Mobile/CommunityCard";


// interface CommunityCardProps {
//   logo?: string;
//   name: string;
//   address: string;
//   description: string;
//   // resourceCount: number;
//   // communityId?: string;
//   onViewResources?: () => void;
// }




const PartnerCommunities: React.FC = () => {
  // Mock data for communities - in production, this would come from an API
  const { allCommunities: communities, isLoadingCommunities } =
    useLoadCommunities();
  // console.log(communities);

  const [communityResourceID, setCommunityResourceID] = useState("");
  const [viewCommunityResources, setViewCommunityResources] = useState(false);

  const handleSetViewCommunityResources = (
    communityId: string,
    isOpen: boolean
  ) => {
    setViewCommunityResources(isOpen);
    setCommunityResourceID(communityId);
  };
  // const communities: CommunityCardProps[] = [
  //   {
  //     name: 'Union Kitchen',
  //     address: '1231-B Marion Barry Ave SE Washington, DC 20020',
  //     logo: 'https://via.placeholder.com/150',
  //     kitchenSpaces: 30,
  //     eventSpaces: 4,
  //     documentations: 100,
  //     moreCount: 3,
  //   },
  //   {
  //     name: 'Dreaming Out Loud',
  //     address: '1231-B Marion Barry Ave SE Washington, DC 20020',
  //     logo: 'https://via.placeholder.com/150',
  //     kitchenSpaces: 30,
  //     eventSpaces: 4,
  //     documentations: 100,
  //     moreCount: 3,
  //   },
  //   {
  //     name: 'Kitchen Of Purpose',
  //     address: '1231-B Marion Barry Ave SE Washington, DC 20020',
  //     logo: 'https://via.placeholder.com/150',
  //     kitchenSpaces: 30,
  //     eventSpaces: 4,
  //     documentations: 100,
  //     moreCount: 3,
  //   },
  // ];

  const [displayedCommunities, setDisplayedCommunities] = React.useState(
    communities?.slice(0, 6) || []
  );
  const [hasMore, setHasMore] = React.useState(
    communities?.length && communities.length > 6
  );

  const handleLoadMore = () => {
    // In production, this would fetch more communities from an API
    // For now, we'll just show that there are no more to load
    setHasMore(false);
  };

  useEffect(() => {
    document.title = `HomeCook | Communities`;
    setDisplayedCommunities(communities?.slice(0, 6) || []);
    setHasMore(communities?.length && communities.length > 6);
  }, [communities]);
  
  return (
    <div className="min-h-screen bg-[#FFFFFF] py-12 px-4  relative">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="font-raleway font-bold text-xl">
            <span className="text-primaryDark-0">Communities </span>
            <span className="text-primaryDark-0">Powering </span>
            <span className="text-primaryDark-0">
              Local <br />
            </span>
            <span className="text-primaryDark-0">Food Businesses.</span>
          </h1>
        </div>

        {/* Community Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-8">
          {isLoadingCommunities ? (
            // Show skeleton loaders while communities are being fetched
            Array.from({ length: 6 }).map((_, index) => (
              <CommunityCardSkeleton key={`skeleton-${index}`} />
            ))
          ) : displayedCommunities && displayedCommunities.length > 0 ? (
            displayedCommunities.map((community: CommunitySchema, index: number) => (
              <CommunityCard 
                key={index} 
                name={community?.name || ''} 
                description={community?.description || ''} 
                address={community?.address || ''} 
                logo={community?.logo || ''} 
                // resourceCount={(community as CommunitySchema)?.resource_count || 0}
                // communityId={community?.id}
                onViewResources={() => handleSetViewCommunityResources(community?.id || '', true)}
              />
            ))
          ) : (
            <div className="col-span-full text-center py-12 text-[#013847]/60">
              No communities to show
            </div>
          )}
        </div>

        {/* Load More Button */}
        {hasMore && (
          <div className="flex justify-center mt-8">
            <button
              onClick={handleLoadMore}
              className="bg-primaryDark-400 border-0 hover:bg-primaryDark-300 text-white font-raleway font-semibold py-3 px-8 rounded-lg transition-colors shadow-sm"
            >
              Load More
            </button>
          </div>
        )}
      </div>

      <CommunityResourcesModal
        isOpen={viewCommunityResources}
        communityId={communityResourceID}
        closeAppModal={() => setViewCommunityResources(false)}
      />
    </div>
  );
};

export default PartnerCommunities;
